function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import TabColumnView from '@/components/tableau/datasource/TabColumnView';
import BiReportService from '@/apps/data-platform/services/visualization/bi_report_service';
import tasks from '@/js/tasks';
export default {
  name: 'FormChangeMetaDataReport',
  components: {
    TabColumnView: TabColumnView
  },
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      tab: null,
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      response_text: '',
      valid_response_text: true,
      fields: [{
        key: 'name',
        label: 'Column',
        class: 'w-15'
      }, {
        key: 'business_definition',
        label: 'Business Definition',
        class: 'w-15'
      }, {
        key: 'field_name',
        label: 'Original column',
        class: 'w-20'
      }, {
        key: 'datatype',
        label: 'Datatype',
        class: 'w-10'
      }, {
        key: 'visualization_type',
        label: 'Visualization Type',
        class: 'w-8 text-center'
      }, {
        key: 'calculated_field',
        label: 'Calculated Field?',
        class: 'w-3 text-center'
      }, {
        key: 'formula',
        label: 'Formula'
      }, {
        key: 'sensitive_data',
        label: 'Sensitive?',
        class: 'w-3 text-center'
      }, {
        key: 'masked',
        label: 'Masked?',
        class: 'w-3 text-center'
      }, {
        key: 'business_term',
        label: 'Business Term',
        class: 'w-15'
      }],
      filterOriginDs: '',
      filterRequestDs: '',
      objRequestDs: Object,
      objOriginDs: Object,
      diffColumnBd: Object,
      diffColumnBt: Object,
      diffRequest: Object,
      diffRequestDs: Object
    };
  },
  computed: _objectSpread({}, mapState('data-platform', ['selectDomain', 'selectSubdomain'])),
  beforeMount: function beforeMount() {
    this.onTableauOwnerDs();
  },
  created: function created() {
    console.log(this.item);
    console.log(this.selectDomain);
  },
  methods: {
    onTableauOwnerDs: function onTableauOwnerDs() {
      var _this = this;
      this.objRequestDs = _objectSpread({}, this.item.objectReference);
      this.objRequestDs.request_id = this.item.id;
      this.objRequestDs.applicant = this.item.applicant;
      this.objRequestDs['document_id'] = this.item.report_id;
      this.objOriginDs = {};
      this.diffColumnBdDs = {};
      this.diffColumnBtDs = {};
      var columns = [];
      this.item.fields.forEach(function (element, index) {
        columns.push(_objectSpread({}, element[index]['fields']));
      });
      this.objRequestDs['columns'] = columns;
      var data = {
        domain: window.userInfo.domain,
        clauses: {
          document_id: this.item.report_id
        }
      };
      BiReportService.reportQuery(data).then(function (res) {
        if (res.code === 200) {
          _this.objOriginDs = _objectSpread({}, res.data.result);
          for (var i in _this.objOriginDs) {
            if (_this.objOriginDs[i] !== _this.objRequestDs[i]) {
              if (typeof _this.objOriginDs[i] === 'string') {
                _this.diffRequestDs["".concat(i)] = true;
              } else if (_typeof(_this.objOriginDs[i]) === 'object') {
                for (var j in _this.objOriginDs[i]) {
                  var a = _objectSpread({}, _this.objOriginDs[i][j]);
                  var b = _objectSpread({}, _this.objRequestDs[i][j]);
                  if (a.business_definition !== b.business_definition) {
                    _this.diffColumnBdDs["".concat(a.name)] = true;
                  }
                  if (a.business_term !== b.business_term) {
                    _this.diffColumnBtDs["".concat(a.name)] = true;
                  }
                }
              }
            }
          }
        }
      });
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    onCloseModal: function onCloseModal() {
      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$emit('onCloseModal', reload);
    },
    onAccept: function onAccept() {
      var _this2 = this;
      if (this.response_text.trim() === '') {
        this.valid_response_text = false;
        this.dangerMessage = 'Please complete Message to reply';
        this.dismissCountDown = this.dismissSecs;
        return;
      }
      var data = _objectSpread(_objectSpread({
        response_text: this.response_text,
        domain: window.userInfo.domain
      }, this.objRequestDs), {}, {
        status: 'APPROVED',
        type_flow: 'CHANGE_METADATA'
      });
      BiReportService.reportSendAssignment(data).then(function (res) {
        if (res.code === 200 && res.success) {
          tasks.toast.success("Successful request!");
          //this.$toast.success('Successful request!')
          _this2.onCloseModal(true);
        }
      });
    },
    onReject: function onReject() {
      var _this3 = this;
      if (this.response_text.trim() === '') {
        this.valid_response_text = false;
        this.dangerMessage = 'Please complete Message to reply';
        this.dismissCountDown = this.dismissSecs;
        return;
      }
      var data = _objectSpread(_objectSpread({
        response_text: this.response_text,
        domain: window.userInfo.domain
      }, this.objRequestDs), {}, {
        status: 'REJECTED',
        type_flow: 'CHANGE_METADATA'
      });
      BiReportService.reportSendAssignment(data).then(function (res) {
        if (res.code === 200 && res.success) {
          tasks.toast.success("Successful request!");
          //this.$toast.success('Successful request!')
          _this3.onCloseModal(true);
        }
      });
    }
  }
};